import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import DetailedBlog from "../../components/DetailedBlog/DetailedBlog";
import GoHome from "../../components/GoHome/GoHome";
import RelatedBlogs from "../../components/RelatedBlogs/RelatedBlogs";
import Loading from "../../components/ui/Loading";
import { fetchBlog } from "../../features/blog/blogSlice";

function Blog() {
  const { blog, isLoading, isError, error } = useSelector(
    (state) => state.blog
  );
  const dispatch = useDispatch();
  const { blogId } = useParams();

  useEffect(() => {
    dispatch(fetchBlog(blogId));
  }, [dispatch, blogId]);

  const { id, tags } = blog || {};

  // decide what to render
  let content = null;
  if (isLoading) content = <Loading />;

  if (!isLoading && isError) content = <div>{error}</div>;

  if (!isLoading && !isError && !blog?.id) {
    content = <div>No video found!</div>;
  }

  if (!isLoading && !isError && blog?.id) {
    content = (
      <section className="post-page-container">
        {/* <!-- detailed post  --> */}
        <DetailedBlog blog={blog} />
        <aside>
          <h4 className="mb-4 text-xl font-medium" id="lws-relatedPosts">
            Related Posts
          </h4>
          <RelatedBlogs currentBlogId={id} tags={tags} />
        </aside>
      </section>
    );
  }
  return (
    <>
      <GoHome />
      {content}
    </>
  );
}

export default Blog;
